import Route from 'cio/routes/base';

export default class LogsIndexRoute extends Route {
  redirect() {
    this.router.transitionTo(
      'logs.list',
      { tab: 'identified' },
      {
        queryParams: {
          // pass query params already in the URL:
          ...this.router.currentRoute.queryParams,
        },
      },
    );
  }
}
